/* src/app/modules_v2/booking/locations/components/sections/location-staff-section/location-staff-section.component.css */
.staff-section {
  padding: 20px;
}
.factuone-button {
  background-color: #e3fd64 !important;
  color: #1a1d23 !important;
}
.factuone-button:hover:not([disabled]) {
  background-color: #e59700 !important;
}
.factuone-button[disabled] {
  background-color: #ccc !important;
  color: #666 !important;
}
.section-header h6.fw-bold {
  color: #333;
  font-size: 18px;
  margin-bottom: 5px;
}
.section-header .text-muted {
  font-size: 13px;
  color: #666;
}
.d-flex.gap-2 {
  gap: 10px;
}
.w-100 {
  width: 100%;
}
mat-form-field {
  width: 100%;
}
.staff-table-container {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}
.staff-table {
  width: 100%;
  border-collapse: collapse;
}
.staff-table thead {
  background: #f5f5f5;
  border-bottom: 2px solid #e0e0e0;
}
.staff-table th {
  padding: 15px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.staff-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}
.staff-table tbody tr:hover {
  background-color: #fafafa;
}
.staff-table tbody tr:last-child {
  border-bottom: none;
}
.staff-table td {
  padding: 15px;
  font-size: 14px;
  color: #333;
  vertical-align: middle;
}
.staff-info {
  display: flex;
  align-items: center;
  gap: 10px;
}
.staff-icon {
  color: #666;
  font-size: 20px;
}
.staff-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.staff-name {
  font-weight: 500;
}
.staff-full-name {
  font-size: 12px;
  color: #888;
}
.staff-email,
.staff-phone {
  color: #555;
}
.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}
.status-badge.status-active {
  background: #e8f5e9;
  color: #2e7d32;
}
.status-badge.status-inactive {
  background: #ffebee;
  color: #c62828;
}
.status-badge.status-archived {
  background: #f5f5f5;
  color: #757575;
}
.color-indicator {
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  margin: 0 auto;
}
.concepts-count {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: #f5f5f5;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}
.small-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.action-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.pagination-container {
  padding: 20px;
  border-top: 1px solid #e0e0e0;
}
.pagination-info,
.pagination-size {
  font-size: 14px;
  color: #666;
}
.pagination-controls button {
  margin: 0 2px;
}
.pagination-controls button.active {
  background-color: var(--cf-chrome);
  color: white;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background: #fafafa;
  text-align: center;
}
.empty-state mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #999;
  margin-bottom: 20px;
}
.empty-state h5 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.empty-state p {
  font-size: 14px;
  color: #666;
  margin-bottom: 25px;
  max-width: 400px;
}
.empty-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
.loading-state {
  padding: 60px 20px;
}
@media (max-width: 1024px) {
  .staff-table {
    font-size: 13px;
  }
  .staff-table th,
  .staff-table td {
    padding: 12px 10px;
  }
}
@media (max-width: 768px) {
  .staff-section {
    padding: 15px;
  }
  .staff-table-container {
    overflow-x: auto;
  }
  .staff-table {
    min-width: 700px;
  }
  .empty-state {
    padding: 60px 15px;
  }
  .empty-actions {
    flex-direction: column;
    width: 100%;
  }
}
/*# sourceMappingURL=location-staff-section.component.css.map */
